import { Link } from 'react-router-dom';
import { ROUTES } from '@/shared/config/routes';
import { formatDate } from '@/shared/lib/utils/date';
import { CategoryPill } from './CategoryPill';
import type { ArticleSummary } from '../model/types';

/** Standard article card used in grids and "keep reading" sections. */
export function ArticleCard({ article }: { article: ArticleSummary }) {
  return (
    <Link
      to={ROUTES.article(article.slug)}
      className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:border-zinc-300 hover:shadow-xl dark:hover:border-zinc-700"
    >
      <div className="aspect-[4/3] shrink-0 overflow-hidden bg-zinc-100 dark:bg-zinc-800">
        {article.coverUrl ? (
          <img
            src={article.coverUrl}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        ) : null}
      </div>
      <div className="flex flex-1 flex-col p-4">
        <CategoryPill category={article.category} className="mb-2.5" />
        <h3 className="flex-1 font-display text-[15px] font-bold leading-snug text-foreground transition-colors group-hover:text-amber-500 dark:group-hover:text-amber-400">
          {article.title}
        </h3>
        <div className="mt-3 flex items-center gap-2 font-mono text-[10px] text-muted-foreground">
          <span>{article.readTime} min read</span>
          {article.publishedAt ? (
            <>
              <span>·</span>
              <span>{formatDate(article.publishedAt)}</span>
            </>
          ) : null}
        </div>
      </div>
    </Link>
  );
}
